import React from 'react';

export const Footer = ({noprint}) => (
  <div className={"footer" + (noprint ? ' noprint' : '')}>
    <p className="bold">We're your friends and neighbors.  We're the Foothill Community Democrats!</p>
    <p>Come join us as we work together to ensure equality and prosperity for all Americans and to restore our place as a beacon of true Democracy for the world.</p>
  </div>
);

